module.exports = __webpack_public_path__ + "img/image1.4e48e1f8.png";